import React from 'react'
import { DraggableSectionProps } from './DraggableSection.types'
import styles from './DraggableSection.module.scss'
import cl from 'classnames'
import {
  Draggable,
  DraggableProvided,
  DraggableStateSnapshot
} from 'react-beautiful-dnd'
import { Checkbox, SectionContainer, Text2 } from 'components/shared'
import { IconDragHandle } from 'assets'

const DraggableSectionComponent = (props: DraggableSectionProps) => {
  const {
    className,
    style,
    label,
    isChecked,
    onCheckboxClick,
    index,
    children
  } = props

  return (
    <Draggable
      key={label}
      draggableId={label}
      index={index}
      isDragDisabled={false}
    >
      {(provided: DraggableProvided,
        snapshot: DraggableStateSnapshot
      ) => {
        return (
          <SectionContainer
            ref={provided.innerRef}
            {...provided.draggableProps}
            id={label}
            className={cl(styles.container, className)}
            style={{
              ...provided.draggableProps.style,
              ...style
            }}
          >
            <span {...provided.dragHandleProps}>
              <IconDragHandle fill={styles.primary} />
            </span>

            {children || (
              <>
                <Checkbox
                  isChecked={isChecked}
                  style={{ marginLeft: 10 }}
                  onClick={onCheckboxClick}
                />
                <Text2
                  bold
                  overflowEllipsis
                  style={{ marginLeft: 10 }}
                >
                  {label}
                </Text2>
              </>
            )}
          </SectionContainer>
        )
      }}
    </Draggable>
  )
}

const DraggableSection = DraggableSectionComponent
export { DraggableSection }
